export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`;
export const IMAGE_URL = `${process.env.REACT_APP_IMAGE_URL}`;
